import ResponseManager from "helpers/responseManager";
import TokenManager from "helpers/tokenManager";
import useAppDispatch from "hooks/store/useAppDispatch";
import { useLayoutEffect } from "react";

const SessionProvider = ({ children }) => {
	const dispatch = useAppDispatch();

	useLayoutEffect(() => {
		TokenManager.dispatch = dispatch;
		ResponseManager.dispatch = dispatch;
	}, [dispatch]);

	return children;
};

export default SessionProvider;